<template>
  <div>
    <div>
      HELLO WORLD Teleconference Support
    </div>

  </div>
</template>

<script>

export default {
  name: 'TeleconferenceSupport',
  components: {

  },
  data () {
    return {

    }
  },
  /// ////
  computed: {

  },
  /// ////
  mounted: function () {

  },
  /// ////
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }

  }
}

</script>
<style>

</style>
